// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full-spinner {\r\n  position: absolute;\r\n  height: 100%;\r\n  width: 100%;\r\n  background: #0000006b;\r\n  z-index: 200;\r\n}\r\n\r\n.full-spinner-img {\r\n  width: 300px;\r\n  height: 100px;\r\n  padding: 20px;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  margin: -70px 0 0 -170px;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
